<div [formGroup]="formGroup">
  <mat-slide-toggle formControlName="sendMailIfCompleted" class="mb1">
    {{ 'INVOKING_USER_SECTION.SEND_MAIL_IF_COMPLETED' | translate }}
  </mat-slide-toggle>

  <mat-form-field *ngIf="formGroup.get('sendMailIfCompleted').value" class="full-width">
    <mat-label>{{ 'CLIENT.EMAIL' | translate }}</mat-label>
    <input matInput formControlName="email" />
    <mat-hint>{{ 'INVOKING_USER_SECTION.EMAIL_FIELD_HINT' | translate }}</mat-hint>
    <mat-error><app-input-errors [control]="formGroup.get('email')"></app-input-errors></mat-error>
  </mat-form-field>
</div>
